<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="interestlist">
                    <div class="row">
                        <div class="col-md-12">
                            <br />
                            <div class="alert alert-success">
                                Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)
                                <img height="1" width="1" style="display:none;" alt="" src="https://dc.ads.linkedin.com/collect/?pid=565489&fmt=gif
https://dc.ads.linkedin.com/collect/?pid=565489&fmt=gif
" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <form v-on:submit.prevent="onSubmit" class="interestButtonList">
                                <div class="col-md-7">
                                    <div class="main-content text-left">
                                        <hr>
                                        <h2 >
                                        Topics Of Interests:
                                        </h2>
                                        <img v-if="user && getDefaultPlan" :src="shareSaleSrc" width="1" height="1">
                                    </div>
                                </div>
                                <div class="interest-container">
                                    <button-group v-model="interestIndexes">
                                        <checkbox class="min-padding checkbox-btn" v-for="(interest, interestId) in getAllInterests" :key="interestId" :true-value="interestId" v-bind:style="styleInterestObject(interestId)">
                                            {{interest.interestName}}
                                        </checkbox>
                                        <button v-if="getAllInterests" v-bind:style="[toggleStatus ? { color: '#FFFFFF !important', backgroundColor: this.getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important', 'outline': 'none'} : { color: getCorpButtonColor + '!important', backgroundColor: '#FFFFFF', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important', 'outline': 'none'}]" class="min-padding checkbox-btn" v-bind:class="{ 'active': toggleStatus}" type="button" @click="toggleStatus = !toggleStatus"><i class="fa fa-gift fa-2x" aria-hidden="true"></i> I want it all!</button>
                                    </button-group>
                                </div>
                                <div>
                                    <div>
                                        <div class="headerlevel3 text-left"><h3 class="profile-heading">TONE Teaser Delivery Days (choose at least two days):</h3></div>
                                        <div class="interest-container" style="margin: 0">
                                            <button-group v-model="selectedDays"  style="margin: 25px">
                                                    <span v-for="(day, index) in daysOfWeek">
                                                        <span>
                                                            <checkbox class="min-padding checkbox-btn-days" :key="index" :true-value="index" v-bind:style="styleDays(index)">
                                                                {{day}}
                                                            </checkbox>
                                                        </span>
                                                    </span>
                                            </button-group>
                                        </div>
                                    </div>
                                </div>
                                <div class="submit-btn">
                                    <button v-bind:style="{ backgroundColor: getCorpButtonColor, border: '1px solid' + getCorpHeaderColor +' !important'}" v-if="isUserLoggedIn" id = "interests_submit" class="btn btn-block" type="submit" :disabled = "interestIndexes.length == 0">
                                        Done
                                        <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                    </button>
                                </div>
                            </form>
                            <alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>
                                <span class="icon-info-circled alert-icon-float-left"></span>
                                <strong>Error:</strong>
                                <p id="interests_errormsg">{{error.message}}</p>
                            </alert>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { input, checkbox, buttonGroup, alert, spinner } from 'vue-strap'
import { mapGetters } from 'vuex'
export default {
    name: 'interestlist',
    spinner: false,
    components: {
        'bs-input': input,
        'checkbox': checkbox,
        'button-group': buttonGroup,
        'spinner': spinner,
        alert
    },
    mounted () {
        // let corpId = 0
        // if (this.user.corporation && this.user.corporation.corporationId > 0) {
        //     corpId = this.user.corporation.corporationId
        // }
        // this.$store.dispatch('GETALLINTERESTS', corpId).then(() => {
        // })
        // let loggedUserTemp = sessionStorage.getItem('loggedUserTemp')
        this.$store.dispatch('GETALLEMAILDAYS', this.user.userId).then(() => {
        })
        if (this.user && (this.user.status === 'REGISTER' || this.user.status === 'Registered')) {
            let corpId = 0
            if (this.user.corporation && this.user.corporation.corporationId > 0) {
                corpId = this.user.corporation.corporationId
            }
            this.$store.dispatch('GETALLINTERESTS', corpId).then(() => {
                console.log(this.user.userId)
            })
            this.$store.dispatch('GETALLEMAILDAYS', this.user.userId).then(() => {
            })
            this.shareSaleSrc = `https://shareasale.com/sale.cfm?amount=${this.getDefaultPlan.amount}&tracking=${this.user.userId}&transtype=SALE&merchantID=76371`
        } else {
            this.$router.push('/')
        }
    },
    data: function () {
        return {
            interestIndexes: [],
            daysOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            userInterests: [],
            selectedDays: [1, 3, 4],
            spinner: false,
            toggleStatus: false,
            shareSaleSrc: ''
        }
    },
    watch: {
        'toggleStatus' (to, from) {
            let self = this
            if (self.toggleStatus) {
                self.checkAllInterests()
            } else {
                self.interestIndexes = []
            }
        }
    },
    methods: {
        styleInterestObject (interestId) {
            let isSelected = this.interestIndexes.filter(x => {
                return x.toString() === interestId.toString()
            })
            if (isSelected && isSelected.length > 0) {
                return {
                    color: '#FFFFFF !important',
                    backgroundColor: this.getCorpButtonColor,
                    borderWidth: '1px !important',
                    borderStyle: 'solid !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                    // border: '2px solid' + this.getCorpButtonColor + ' !important'
                }
            } else {
                return {
                    // border: '2px solid' + this.getCorpButtonColor + ' !important',
                    color: this.getCorpButtonColor + ' !important',
                    borderWidth: '1px !important',
                    borderStyle: 'solid !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                }
            }
        },
        styleDays (interestId) {
            let isSelected = this.selectedDays.filter(x => {
                return x.toString() === interestId.toString()
            })
            if (isSelected && isSelected.length > 0) {
                return {
                    color: '#FFFFFF !important',
                    backgroundColor: this.getCorpButtonColor,
                    borderWidth: '1px !important',
                    borderStyle: 'solid !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                    // border: '2px solid' + this.getCorpButtonColor + ' !important'
                }
            } else {
                return {
                    // border: '2px solid' + this.getCorpButtonColor + ' !important',
                    color: this.getCorpButtonColor + ' !important',
                    borderWidth: '1px !important',
                    borderStyle: 'solid !important',
                    borderColor: this.getCorpButtonColor + ' !important'
                }
            }
        },
        spinnerToggle () {
            this.spinner = !this.spinner
        },
        checkAllInterests () {
            // Update Interest Index for selection
            this.interestIndexes = []
            for (var i = 0, l = this.getAllInterests.length; i < l; i++) {
                this.interestIndexes.push(i)
            }
        },
        onSubmit: function () {
            this.spinnerToggle()
            const days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY']
            const daysSelected = []
            this.selectedDays.forEach(index => {
                daysSelected.push(days[index])
            })
            const setDaysData = { userId: this.user.userId, days: daysSelected }
            for (var i = 0, l = this.interestIndexes.length; i < l; i++) {
                let newUserInterest = {}
                let selectedInterest = this.getAllInterests[this.interestIndexes[i]]
                newUserInterest.userId = this.user.userId
                newUserInterest.interestId = selectedInterest.interestId
                newUserInterest.count = 5
                this.userInterests.push(newUserInterest)
            }
            this.$store.dispatch('SETDAYS', {data: setDaysData}).then(() => {
            })
            this.$store.dispatch('SETINTERESTS', {interests: this.userInterests}).then(() => {
                this.spinnerToggle()
            })
        }
    },
    computed: {
        atLeastOneDaySelected () {
            return this.selectedDays.length > 0
        },
        ...mapGetters([
            'getAllInterests', 'isUserLoggedIn', 'error', 'user', 'getDefaultPlan', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'
        ])
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    form.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn {
        padding: 5px 0 10px;
        margin: 5px 0;
        background: #ffffff;
        color: #f0617d;
        width: 49.5% !important;
        line-height: 1.3;
    }
    form.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn-days {
        padding: 5px 0 10px;
        margin: 5px 0;
        background: #ffffff;
        color: #f0617d;
        width: 38.5% !important;
        line-height: 1.3;
    }
    button.min-padding.checkbox-btn.active {
        background: #f0617d !important;
    }
    @media(max-width:767px){
        form.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn {
            width: 100% !important;
        }
        .interestlist .submit-btn .btn {
            width: 100%;
        }
    }
    @media(max-width:767px){
        form.interestButtonList>.interest-container>div.btn-group>button.min-padding.checkbox-btn-days {
            width: 100% !important;
        }
        .interestlist .submit-btn .btn {
            width: 100%;
        }
    }
    .interestlist {
        clear: both;
    }
    .interestlist .interest-container {
        width: 100%;
    }
    .headerlevel2 h2 {
        color: #0D0D0D;
        font-weight: 900;
        margin: 20px 0 20px 0;  /* top right bottom left */
    }
    .headerlevel3 h3 {
        color: #0D0D0D;
        font-weight: 500;
        margin: 20px 0 20px 0;  /* top right bottom left */
    }
</style>
<style>
    /*.interestlist .interestButtonList .checkbox-btn:hover{*/
    /*    !*background: #fff !important;*!*/
    /*    !*color: #f0617d !important;*!*/
    /*}*/
    /*.interestlist .interestButtonList .checkbox-btn.active:hover {*/
    /*    !*background: #f0617d !important;*!*/
    /*    !*color: #fff !important;*!*/
    /*}*/
</style>



// WEBPACK FOOTER //
// InterestList.vue?8ff5a9b0